import { createSlice } from "@reduxjs/toolkit";
import { minerEarnings } from "./MinerEarningActions";

const initialState = {
    loading: false,
    minerEarning: {},
    error: null,
    success: false, // for monitoring the registration process.
  }

const MinerSlice = createSlice({
    name: "MinerSlice",
    initialState,
    reducers: {},
    extraReducers:{
        [minerEarnings.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.minerEarning = payload.data
        },
        [minerEarnings.pending]: (state, {payload}) => {
            state.loading = true
        },
        [minerEarnings.rejected]: (state, {payload}) => {
            state.loading = false
            state.minerEarning = payload
        },
    }
})

export default MinerSlice.reducer